// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","703":"LazyIdentificationBusinessForm","886":"LazyInvitationStep","954":"LazyBusinessInfoFormComponent"}[chunkId] + "." + {"99":"ca9aeb195f1ea935ff1a","703":"8794b78acc22da34b75b","886":"4b3b1de1057eb07b47f6","954":"532acd0e986b730227f9"}[chunkId] + ".js";
};